<template>
  <div class="clients">
    <SectionTitle
      :title="$t('home.clients.title')"
      :subtitle="$t('home.clients.subtitle')"
    />
    <div class="clients-logos" data-aos="fade-up">
      <swiper class="swiper-clients" :options="swiperOptions">
        <swiper-slide
          class="slide-item"
          v-for="(chunk, i) in chunkedLogos"
          :key="i"
        >
          <div class="logos-grid">
            <div class="logo" v-for="(logo, j) in chunk" :key="j">
              <img :src="require(`@/assets/img/clients/${logo}`)" :alt="logo" />
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import SectionTitle from "@/components/SectionTitle";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "Clients",
  components: {
    SectionTitle,
    Swiper,
    SwiperSlide,
  },
  data: () => {
    return {
      swiperOptions: {
        speed: 700,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
      },
      clientsLogos: [],
      windowWidth: window.innerWidth
    };
  },
  computed: {
    chunkedLogos() {
      const chunks = [];
      let chunkSize = 6;
      
      if (this.windowWidth <= 500) {
        chunkSize = 2;
      } else if (this.windowWidth <= 900) {
        chunkSize = 4;
      }
      
      for (let i = 0; i < this.clientsLogos.length; i += chunkSize) {
        chunks.push(this.clientsLogos.slice(i, i + chunkSize));
      }
      return chunks;
    },
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    }
  },
  created() {
    const clientLogosContext = require.context('@/assets/img/clients', false, /\.(png|jpe?g|svg)$/i);
    this.clientsLogos = clientLogosContext.keys().map(key => key.replace('./', ''));
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.clients {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.1);

  background: var(--gray-30);
  padding: 2rem 0;
  border-radius: 10px;

  .clients-logos {
    max-width: 1440px;
    margin: 2rem 0;
    display: flex;
    justify-content: center;

    .slide-item {
      width: 100%;
      height: 300px;
      
      .logos-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(2, 1fr);
        gap: 2rem;
        height: 100%;
        padding: 1.5rem;
      }

      .logo {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 0 1.5rem;

        img {
          max-width: 180px;
          width: auto;
          height: auto;
          max-height: 120px;
          object-fit: contain;
        }
      }
    }

    .swiper-button-prev,
    .swiper-button-next {
      color: var(--blue-50);
    }
  }
}

@media screen and (max-width: 900px) {
  .clients {
    .clients-logos {
      .slide-item {
        height: 250px;
        
        .logos-grid {
          grid-template-columns: repeat(2, 1fr);
          grid-template-rows: repeat(2, 1fr);
          gap: 1.5rem;
        }

        .logo img {
          max-width: 150px;
          max-height: 100px;
        }
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .clients {
    .clients-logos {
      .slide-item {
        height: 200px;
        
        .logos-grid {
          grid-template-columns: 1fr;
          grid-template-rows: repeat(2, 1fr);
          gap: 1rem;
          padding: 1rem;
        }

        .logo {
          padding: 0 1rem;
          
          img {
            max-width: 130px;
            max-height: 80px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1400px) {
  .clients {
    .clients-logos {
      width: 90%;
    }
  }
}
</style>
